const getRequiredEnv = (key: string, value: string | undefined): string => {
  if (!value?.trim()) {
    throw new Error(`Missing required environment variable: ${key}`);
  }

  return value;
};

const getOptionalEnv = (value: string | undefined, fallback = ''): string => {
  return value?.trim() || fallback;
};

export const env = {
  APP_ENV: getRequiredEnv('NEXT_PUBLIC_APP_ENV', process.env['NEXT_PUBLIC_APP_ENV']),
  APP_URL: getRequiredEnv('NEXT_PUBLIC_APP_URL', process.env['NEXT_PUBLIC_APP_URL']),
  API_BASE_URL: getRequiredEnv('NEXT_PUBLIC_API_BASE_URL', process.env['NEXT_PUBLIC_API_BASE_URL']),
  CALENDLY_EVENT_URL: getOptionalEnv(process.env['NEXT_PUBLIC_CALENDLY_EVENT_URL']),
  SITE_URL: getOptionalEnv(process.env['NEXT_PUBLIC_SITE_URL'], process.env['NEXT_PUBLIC_APP_URL']),
  ASSETS_BASE_URL: getOptionalEnv(
    process.env['NEXT_PUBLIC_ASSETS_BASE_URL'],
    process.env['NEXT_PUBLIC_APP_URL'],
  ),
  ENABLE_VERCEL_METRICS: getOptionalEnv(process.env['NEXT_PUBLIC_ENABLE_VERCEL_METRICS']),
} as const;
